<template>
<v-container fluid>
  <component :is="activeComponent"></component>
</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ReportApi from '@/api/admin/report'
import unsoldartworks from './UnsoldArtworks'
import unsoldproducts from './UnsoldProducts'
import productsearch from './ProductSearch.vue'

export default {
  components: {
    unsoldartworks,
    unsoldproducts,
    productsearch
  },
  data () {
    return {
      // activeComponent: null
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters('reports', ['activeArtist']),
    activeComponent () {
      return this.$route.params.report
    }
  },
  async created () {
    // this.activeComponent = this.$route.params.report
    }
}
</script>
